export default __webpack_public_path__ + "static/media/event broadcasting.5885ffae.svg";